import type { LexicalEditor, SerializedEditorState } from "lexical";
import { useFormContext, useWatch } from "react-hook-form";
import toast from "react-hot-toast";
import type { Json } from "../../../__definitions__/database-definitions";
import { useSupabaseCallback } from "../../../server/supabase/hooks";
import type { MomentFormMoment } from "../../moment/types/moment-form-moment";
import { useClaims } from "./use-claims";

export function useHandleMomentLexicalError(): (
  e: Error,
  editor: LexicalEditor,
  undoStack: SerializedEditorState[],
) => Promise<void> {
  const { control, setValue, getValues } = useFormContext<MomentFormMoment>();
  const claims = useClaims();

  useWatch({ control, name: ["id"] });
  const moment_id = getValues("id");

  const writeUndoStack = useSupabaseCallback(
    async ({ supabase }, e: Error, editor: LexicalEditor, undoStack: SerializedEditorState[]) => {
      console.error(e);
      setValue("unrecoverable_error", true);
      toast.error(`Editor Error ${e.message}, please contact support.`);
      await supabase.rpc("log_corrupt_lexical_state", {
        identifier: { type: "moment", moment_id, claims: claims ?? null },
        stack: {
          content: editor.getEditorState().toJSON() as unknown as Json,
          stack: undoStack as unknown as Json,
        },
      });
    },
    [moment_id, claims, setValue],
  );

  return writeUndoStack;
}
